export default __webpack_public_path__ + "static/media/icon_search_delete.6775c3b9.svg";